import request from '@/utils/request'
import { getRequest } from '@/utils'

export function getJSSDKConfig () {
    return request({
        url: '/wechat/wxjs',
        method: 'post',
        data: {
            url: window.location.href,
            'entry_id': getRequest().e
        }
    })
}
